import config from '@/config';

export default function calculation(rheemPrice, validAvgEnergyRate, maxBarHeight) {
  // Initial investment costs
  const electricPrice = +(config.ELECTRIC_PRICE + config.ELECTRIC_INSTALLATION_PRICE);
  // Annual KW by WH Unit Type
  const electricAnnualKilowatts = +(config.ELECTRIC_ANNUAL_KILOWATTS);
  const hybridAnnualKilowatts = +(config.HYBRID_ANNUAL_KILOWATTS);
  // Vars for Charts building
  const maxBarValue = +(config.MAX_HYBRID_PRICE + config.MAX_HYBRID_INSTALLATION_PRICE);
  const investmentElectricBarHeight = ((electricPrice / maxBarValue) * maxBarHeight).toFixed(0);
  const investmentHybridBarHeight = (Math.max((rheemPrice / maxBarValue) * maxBarHeight, 0)).toFixed(0);

  const annualCostElectric = (electricAnnualKilowatts * parseFloat(validAvgEnergyRate)).toFixed(0);
  const annualCostHybrid = (hybridAnnualKilowatts * parseFloat(validAvgEnergyRate)).toFixed(0);

  const annualCostElectricBarHeight = ((annualCostElectric / maxBarValue) * (maxBarHeight * 3)).toFixed(0);
  const annualCostHybridBarHeight = ((annualCostHybrid / maxBarValue) * (maxBarHeight * 3)).toFixed(0);

  // results
  const annualCostSavings = parseFloat(annualCostElectric) - parseFloat(annualCostHybrid);
  const paybackYears = (((rheemPrice - parseFloat(electricPrice)) / annualCostSavings) * 12).toFixed(0);
  const lifetimeROI = (10 * annualCostElectric + electricPrice) - (10 * annualCostHybrid + rheemPrice);
  return {
    investmentElectricBarHeight,
    investmentHybridBarHeight,
    annualCostElectric,
    annualCostHybrid,
    annualCostElectricBarHeight,
    annualCostHybridBarHeight,
    annualCostSavings,
    paybackYears,
    lifetimeROI,
  };
}
